(function($){
        
	// Add Loaded Class
	$('.ptx-formradio').addClass('ptx-formradio--loaded');
  
})(jQuery);